<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-02 11:28:42
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-25 19:02:13
 * @Description: 鲸鱼大事件
 -->

<template>
  <div class="jinr-important-wrapper">
    <div class="jinr-important-content">
      <div class="platform">
        <h2>鲸鱼平台</h2>
        <p>
          鲸鱼专注于互联网+金融模式，运用互联网技术解决金融服务中的用户需求。依托多维度的大数据风控模式，致力为个人、中小微企业提供安全可靠的线上信贷及出借撮合服务。
        </p>
        <ul class="banner-wrapper">
          <li class="banner-item">
            <img src="https://files.jinr.com/jinr-index/img/mid-bg-01.png" alt="" />
            <p class="label">使命</p>
            <div class="mask">
              <p>为广大人民提供安全稳健的普惠金融服务</p>
            </div>
          </li>
          <li class="banner-item">
            <img src="https://files.jinr.com/jinr-index/img/mid-bg-02.png" alt="" />
            <p class="label">理念</p>
            <div class="mask">
              <p>时间投资哲学的践行者，用时间智慧改变人民生活</p>
            </div>
          </li>
          <li class="banner-item">
            <img src="https://files.jinr.com/jinr-index/img/mid-bg-03.png" alt="" />
            <p class="label">愿景</p>
            <div class="mask">
              <p>打造中国最具影响力的新金融生态链</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="line"></div>
    </div>
    <div class="jinr-important-event">
      <h2>鲸鱼大事件</h2>
      <div class="swiper-box">
        <swiper :options="swiperOption" class="jinr-important" ref="mySwiper">
          <swiper-slide class="slide-item">
            <p class="date">2014年09月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-00.png" alt="" />
            </div>
            <p class="text">鲸鱼官网正式上线</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2015年01月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-01.png" alt="" />
            </div>
            <p class="text">交易总额突破1亿元</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2016年04月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-02.png" alt="" />
            </div>
            <p class="text">参加厦门地区互联网金融改革试点接入存证云系统（美亚柏科）</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2016年08月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-03.png" alt="" />
            </div>
            <p class="text">交易总额突破100亿</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2016年12月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-04.png" alt="" />
            </div>
            <p class="text">荣获“中国卓越影响力普惠金融服务机构”大奖</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2017年07月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-05.png" alt="" />
            </div>
            <p class="text">荣获2017中国资产管理金贝奖</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2018年09月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-06.png" alt="" />
            </div>
            <p class="text">成为“厦门市地方金融协会”<br />会员单位</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date at-last">2019年5月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-07.png" alt="" />
            </div>
            <p class="text">接入银行存管系统</p>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-btn swiper-button-prev"></div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-btn swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  name: 'jinr-important',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 'auto',
        loopedSlides: 5,
        on: {
          // click: function() {
          //   this.autoplay.start();
          // }
        }
      }
    };
  }
};
</script>
<style lang="less">
.jinr-important-event {
  position: relative;
  h2 {
    font-family: 'PingFangSC-Medium';
    font-size: 22px;
    color: #333333;
    line-height: 28px;
    text-align: center;
    margin: 40px 0 80px;
  }
  .swiper-box {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .swiper-btn {
      // width: 12px;
      height: 32px;
      position: absolute;
      top: 50%;
      outline: none;
      transform: translateY(-50%);
      z-index: 5;
      cursor: pointer;
    }
    .swiper-button-prev {
      left: 0;
      // background: url('https://files.jinr.com/jinr-index/img/arrow-left.png');
    }
    .swiper-button-next {
      right: 0;
    }
  }
}
.jinr-important {
  width: 1150px;
  margin: 0 auto;
  position: relative;
  .slide-item {
    width: 230px !important;
    height: 350px;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: space-around;
    .date {
      color: #999999;
      position: relative;
      text-align: center;
      i {
        width: 9px;
        height: 9px;
        background: #2c6eff;
        -webkit-box-shadow: 1px 2px 10px 0 #2c6eff;
        box-shadow: 1px 2px 10px 0 #2c6eff;
        position: absolute;
        top: 39px;
        left: 50%;
        border-radius: 50%;
        margin-left: -4.5px;
        z-index: 2;
      }
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        background: #2c6eff;
        left: 50%;
        margin-left: -4px;
        top: 43px;
        z-index: 1;
      }
    }
    .at-last {
      &::after {
        display: none;
      }
    }
    .img-box {
      width: 170px;
      height: 170px;
      margin: 48px auto 24px;
      border-radius: 50%;
      opacity: 0.5;
      background: #ccc;
      overflow: hidden;
      transition: 0.2s linear;
      img {
        width: 100%;
      }
      &:hover {
        opacity: 1;
        -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.36);
        box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.36);
      }
    }
    .text {
      text-align: center;
      font-family: 'PingFangSC-Medium';
      font-size: 16px;
      color: #333333;
      line-height: 30px;
    }
  }
}
</style>

<style lang="less" scoped>
.jinr-important-wrapper {
  position: relative;
  height: 1316px;
  .jinr-important-content {
    // width: 1200px;
    // margin: 0 auto;
    background: #eff3ff;
    box-shadow: 0 10px 14px 0 #e0ebfc;
    .platform {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      padding: 98px 0;
      h2 {
        font-family: 'PingFangSC-Medium';
        font-size: 22px;
        color: #333333;
        line-height: 22px;
        margin-bottom: 48px;
      }
      p {
        text-align: left;
        text-indent: 2em;
        font-size: 18px;
        color: #333333;
        line-height: 28px;
      }
      .banner-wrapper {
        display: flex;
        justify-content: center;
        margin-top: 50px;
        .banner-item {
          width: 268px;
          height: 234px;
          position: relative;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
          }
          .label{
            width:100%;
            text-align: center;
            line-height:26px;
            font-size:24px;
            color:#fff;
            text-indent: 0;
            position:absolute;
            left:0;
            top:61px;
            z-index:2;
          }
          .mask {
            width: 100%;
            height: 100%;
            padding: 44px;
            position: absolute;
            top: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 3;
            box-sizing: border-box;
            p {
              position: relative;
              text-indent: 0;
              top: 80px;
              text-align: center;
              color: #fff;
            }
          }
          &:hover {
            .mask {
              transform: translateY(-100%);
              transition: 0.3s linear;
            }
          }
        }
      }
    }
  }
}
</style>
